import { Component, EventEmitter, Input, Output } from "@angular/core";
import { IrPieChartCard } from "../../../investor-report/pojo/ir-common-classes";
import { NgForOf, NgIf } from "@angular/common";
import { SharedComponentsModule } from "../../module/shared-components.module";

@Component({
  selector: 'app-pie-chart-simple',
  standalone: true,
  templateUrl: './pie-chart-simple.component.html',
  styleUrls: ['./pie-chart-simple.component.scss'],
  imports: [
    NgForOf,
    NgIf,
    SharedComponentsModule,
  ],
})
export class PieChartSimpleComponent {
  @Input({ required: true }) data: IrPieChartCard;
  @Input({ required: true }) isAdmin = false;
  @Output() editClicked = new EventEmitter<void>();
}
